import React from 'react';

function SensorSmoke() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_241_1102)">
        <path
          d="M73.132 57.196C73.648 53.952 74 47.47 74 39.994C74 32.518 73.646 25.99 73.126 22.76C71.948 14.53 65.432 8.028 57.196 6.868C53.952 6.352 47.47 6 39.994 6C32.518 6 25.992 6.354 22.76 6.874C14.53 8.052 8.028 14.568 6.868 22.804C6.352 26.048 6 32.53 6 40.006C6 47.482 6.354 54.01 6.874 57.24C8.052 65.47 14.568 71.972 22.804 73.132C26.048 73.648 32.53 74 40.006 74C47.482 74 54.01 73.646 57.24 73.126C65.47 71.948 71.972 65.432 73.132 57.196Z"
          fill="#F7F4F1"
        />
        <path
          d="M68.3984 54.7399C68.8404 51.9599 69.1424 46.4019 69.1424 39.9959C69.1424 33.5899 68.8384 27.9939 68.3944 25.2239C67.3844 18.1699 61.7984 12.5959 54.7404 11.6019C51.9604 11.1599 46.4024 10.8579 39.9964 10.8579C33.5904 10.8579 27.9944 11.1619 25.2244 11.6059C18.1704 12.6159 12.5964 18.2019 11.6024 25.2599C11.1604 28.0399 10.8584 33.5979 10.8584 40.0039C10.8584 46.4099 11.1624 52.0059 11.6064 54.7759C12.6164 61.8299 18.2024 67.4039 25.2604 68.3979C28.0404 68.8399 33.5984 69.1419 40.0044 69.1419C46.4104 69.1419 52.0064 68.8379 54.7764 68.3939C61.8304 67.3839 67.4044 61.7979 68.3984 54.7399Z"
          fill="white"
        />
        <path
          d="M73.9181 22.6479C72.6941 14.0959 65.8621 7.2819 57.3221 6.0799C53.9181 5.5379 47.2781 5.2019 39.9961 5.2019C32.7141 5.2019 26.0301 5.5399 22.6481 6.0839C14.0961 7.3079 7.28215 14.1379 6.08015 22.6799C5.53815 26.0859 5.20215 32.7239 5.20215 40.0059C5.20215 47.2879 5.54015 53.9719 6.08415 57.3539C7.30815 65.9059 14.1401 72.7199 22.6801 73.9219C26.0841 74.4639 32.7241 74.7999 40.0061 74.7999C47.2881 74.7999 53.9721 74.4619 57.3541 73.9179C65.9041 72.6939 72.7161 65.8679 73.9241 57.3139C74.4661 53.9059 74.8001 47.2719 74.8001 39.9939C74.8001 32.7159 74.4621 26.0279 73.9181 22.6459V22.6479ZM72.3421 57.0719C72.3421 57.0719 72.3421 57.0819 72.3401 57.0859C71.2341 64.9399 64.9781 71.2119 57.1121 72.3379C53.7941 72.8699 47.2401 73.2019 40.0041 73.2019C32.7681 73.2019 26.2561 72.8739 22.9141 72.3419C15.0601 71.2359 8.78815 64.9799 7.66215 57.1159C7.13015 53.7979 6.79815 47.2419 6.79815 40.0079C6.79815 32.7739 7.12615 26.2599 7.65815 22.9179C8.76415 15.0639 15.0201 8.7919 22.8841 7.6659C26.2001 7.1339 32.7561 6.8019 39.9921 6.8019C47.2281 6.8019 53.7401 7.1299 57.0821 7.6619C64.9361 8.7679 71.2081 15.0239 72.3341 22.8879C72.8661 26.2039 73.1981 32.7599 73.1981 39.9959C73.1981 47.2319 72.8701 53.7439 72.3401 57.0719H72.3421Z"
          fill="#83827F"
        />
        <path
          d="M54.8666 10.8119C51.9426 10.3459 46.2446 10.0579 39.9966 10.0579C33.7486 10.0579 28.0126 10.3479 25.1106 10.8159C17.7306 11.8719 11.8506 17.7679 10.8126 25.1359C10.3466 28.0599 10.0586 33.7579 10.0586 40.0059C10.0586 46.2539 10.3486 51.9899 10.8146 54.8919C11.8706 62.2719 17.7666 68.1519 25.1346 69.1899C28.0586 69.6559 33.7566 69.9439 40.0046 69.9439C46.2526 69.9439 51.9886 69.6539 54.8906 69.1879C62.2686 68.1319 68.1486 62.2399 69.1906 54.8599C69.6546 51.9339 69.9446 46.2399 69.9446 39.9979C69.9446 33.7559 69.6546 28.0139 69.1866 25.1119C68.1306 17.7319 62.2346 11.8519 54.8666 10.8139V10.8119ZM67.6086 54.6139C67.6086 54.6139 67.6086 54.6239 67.6066 54.6279C66.6646 61.3099 61.3426 66.6459 54.6506 67.6039C51.8126 68.0599 46.2006 68.3419 40.0046 68.3419C33.8086 68.3419 28.2326 68.0599 25.3726 67.6059C18.6906 66.6639 13.3546 61.3419 12.3966 54.6499C11.9406 51.8119 11.6586 46.1999 11.6586 40.0039C11.6586 33.8079 11.9406 28.2319 12.3946 25.3719C13.3366 18.6899 18.6586 13.3539 25.3506 12.3959C28.1886 11.9399 33.8006 11.6579 39.9966 11.6579C46.1926 11.6579 51.7686 11.9399 54.6286 12.3939C61.3106 13.3359 66.6466 18.6579 67.6046 25.3499C68.0606 28.1879 68.3426 33.7999 68.3426 39.9959C68.3426 46.1919 68.0606 51.7659 67.6086 54.6139Z"
          fill="#83827F"
        />
        <path
          d="M49.8539 52.9438H30.2539C28.0539 52.9438 26.2539 54.7438 26.2539 56.9438C26.2539 59.1438 28.0539 60.9438 30.2539 60.9438H49.8539C52.0539 60.9438 53.8539 59.1438 53.8539 56.9438C53.8539 54.7438 52.0539 52.9438 49.8539 52.9438Z"
          fill="#83827F"
        />
        <path
          d="M33.2564 54.9438H30.8564C29.7519 54.9438 28.8564 55.8393 28.8564 56.9438C28.8564 58.0484 29.7519 58.9438 30.8564 58.9438H33.2564C34.361 58.9438 35.2564 58.0484 35.2564 56.9438C35.2564 55.8393 34.361 54.9438 33.2564 54.9438Z"
          fill="white"
        />
        <path
          d="M29.5105 20.5658C29.5105 19.6822 28.7942 18.9658 27.9105 18.9658C27.0269 18.9658 26.3105 19.6822 26.3105 20.5658V28.5658C26.3105 29.4495 27.0269 30.1658 27.9105 30.1658C28.7942 30.1658 29.5105 29.4495 29.5105 28.5658V20.5658Z"
          fill="url(#paint0_linear_241_1102)"
        />
        <path
          d="M40.0541 18.9659H40.1581C40.9841 18.9659 41.6541 19.6359 41.6541 20.4619V28.6679C41.6541 29.4939 40.9841 30.1639 40.1581 30.1639H39.9521C39.1261 30.1639 38.4561 29.4939 38.4561 28.6679V20.5639C38.4561 19.6799 39.1721 18.9639 40.0561 18.9639L40.0541 18.9659Z"
          fill="url(#paint1_linear_241_1102)"
        />
        <path
          d="M52.1986 18.9659H52.3026C53.1286 18.9659 53.7986 19.6359 53.7986 20.4619V28.6679C53.7986 29.4939 53.1286 30.1639 52.3026 30.1639H52.0966C51.2706 30.1639 50.6006 29.4939 50.6006 28.6679V20.5639C50.6006 19.6799 51.3166 18.9639 52.2006 18.9639L52.1986 18.9659Z"
          fill="url(#paint2_linear_241_1102)"
        />
        <path
          d="M47.7264 22.966C47.7264 22.0823 47.01 21.366 46.1264 21.366C45.2427 21.366 44.5264 22.0823 44.5264 22.966V26.166C44.5264 27.0496 45.2427 27.766 46.1264 27.766C47.01 27.766 47.7264 27.0496 47.7264 26.166V22.966Z"
          fill="url(#paint3_linear_241_1102)"
        />
        <path
          d="M35.5818 22.966C35.5818 22.0823 34.8655 21.366 33.9818 21.366C33.0982 21.366 32.3818 22.0823 32.3818 22.966V26.166C32.3818 27.0496 33.0982 27.766 33.9818 27.766C34.8655 27.766 35.5818 27.0496 35.5818 26.166V22.966Z"
          fill="url(#paint4_linear_241_1102)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_241_1102"
          x="3.80215"
          y="3.8019"
          width="75.5977"
          height="75.5979"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.6" dy="1.6" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_241_1102"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_241_1102"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_241_1102"
          x1="26.7606"
          y1="19.9676"
          x2="31.303"
          y2="21.4562"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_241_1102"
          x1="38.9059"
          y1="19.9656"
          x2="43.4459"
          y2="21.4526"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_241_1102"
          x1="51.0504"
          y1="19.9656"
          x2="55.5904"
          y2="21.4526"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_241_1102"
          x1="44.9764"
          y1="21.9384"
          x2="48.7616"
          y2="24.1093"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_241_1102"
          x1="32.8319"
          y1="21.9384"
          x2="36.6171"
          y2="24.1093"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SensorSmoke;
